import type { SVGProps } from "react";

export const VegetarianMarkIn = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
      }}
      viewBox="0 0 25 25"
      className={className}
      {...props}
    >
      <path
        d="M0 0h25v25H0z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M1.53 1.53h21.93v21.93H1.53z"
        style={{
          fill: "none",
          stroke: "#15a151",
          strokeWidth: "1.08px",
        }}
      />
      <path
        d="M12.5 18.25a5.75 5.75 0 0 0 5.75-5.75c0-3.17-2.58-5.75-5.75-5.75S6.75 9.33 6.75 12.5s2.58 5.75 5.75 5.75"
        style={{
          fill: "#15a151",
          fillRule: "nonzero",
        }}
      />
    </svg>
  );
};
